module.exports = __webpack_public_path__ + "static/media/Revert.46300a56.svg";